
import React, { useEffect, useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    Flex,
    Image,
    ModalHeader,
    ModalBody,
    Text,
    ModalFooter,
    Button
} from "@chakra-ui/react";



export const ResponseModal = ({ openResponseModal, responseModal, setResponseModal, setOpenResponseModal }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (openResponseModal) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [openResponseModal]);

    const handleClose = () => {
        setIsOpen(false);
        setOpenResponseModal(false)
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} isCentered>
            <ModalOverlay />
            {(responseModal?.error === true) &&
                <ModalContent maxW="400px">
                    <Flex
                        p="32px 32px 24px 32px"
                        alignContent="initial"
                        alignItems={"flex-start"}
                    >
                        <Image
                            w="24px"
                            h="24px"
                            src={"/images/icons/ErrorIcon.svg"} />
                        <Flex
                            flexDirection="column"

                        >

                            <ModalHeader
                                p="0  0 0 24px"
                                fontSize="16px"
                            >

                                {responseModal?.title}


                            </ModalHeader>
                            <ModalBody
                                p="0  0 0 24px"
                            >
                                <Text fontSize="sm" mt={1}>
                                    {responseModal?.description}

                                </Text>
                            </ModalBody>
                            <ModalFooter mt="16px" p="0  0 0 24px" gap="8px">

                                <Button
                                    w="49px"
                                    h="32px"
                                    borderRadius="2px"
                                    fontSize="14px"
                                    color="white"
                                    backgroundColor="#1890FF"
                                    onClick={() => {
                                        handleClose();
                                    }}
                                >
                                    Ok
                                </Button>
                            </ModalFooter>
                        </Flex>

                    </Flex>
                </ModalContent>
            }
            {(responseModal.error !== true) &&

                <ModalContent maxW="400px">
                    <Flex
                        p="32px 32px 24px 32px"
                        alignContent="initial"
                        alignItems={"flex-start"}
                    >
                        <Image
                            w="24px"
                            h="24px"
                            src={"/images/icons/SuccessIcon.svg"} />
                        <Flex
                            flexDirection="column"

                        >

                            <ModalHeader
                                p="0  0 0 24px"
                                fontSize="16px"
                            >

                                Seu estorno foi realizado com sucesso


                            </ModalHeader>
                            <ModalBody
                                p="0  0 0 24px"
                            >
                                <Text fontSize="sm" mt={1}>
                                    Em alguns instantes você pode emitir sua carta de estorno caso seja necessária.E

                                </Text>
                            </ModalBody>
                            <ModalFooter mt="16px" p="0  0 0 24px" gap="8px">

                                <Button
                                    w="49px"
                                    h="32px"
                                    borderRadius="2px"
                                    fontSize="14px"
                                    color="white"
                                    backgroundColor="#1890FF"
                                    onClick={() => {
                                        handleClose();
                                    }}
                                >
                                    Ok
                                </Button>
                            </ModalFooter>
                        </Flex>

                    </Flex>
                </ModalContent>
            }
        </Modal>
    );
};
